import { create } from 'zustand'
import Cookies from 'js-cookie'
import { VENDURE_AUTH_TOKEN_HEADER_KEY } from '@/config'
const USER_ID_KEY = 'nobrinde-user-id'

interface User {
    id: string
    identifier: string
}

interface AuthState {
    isAuthenticated: boolean
    token: string | null
    user: User | null
    userId: string | null
    login: (token: string, user: User, rememberMe?: boolean) => void
    logout: () => void
}

export const useAuthStore = create<AuthState>((set) => {
    // The vendure-auth-token cookie holds Vendure's bearer session token, which is
    // also issued (and written back here by the Apollo auth link) for anonymous/guest
    // sessions to keep the active order alive across requests. It is NOT proof of a
    // logged-in customer, so login state must be derived from userId instead, which
    // is only ever written by an explicit login().
    const token = Cookies.get(VENDURE_AUTH_TOKEN_HEADER_KEY) || null
    const userId = localStorage.getItem(USER_ID_KEY)
    const isAuthenticated = !!userId

    return {
        isAuthenticated,
        token,
        user: null,
        userId,
        login: (newToken: string, user: User, rememberMe = false) => {
            // Set cookie
            if (rememberMe) {
                Cookies.set(VENDURE_AUTH_TOKEN_HEADER_KEY, newToken, { expires: 30 })
            } else {
                Cookies.set(VENDURE_AUTH_TOKEN_HEADER_KEY, newToken)
            }
            localStorage.setItem(USER_ID_KEY, user.id)
            set({ isAuthenticated: true, token: newToken, user, userId: user.id })
        },
        logout: () => {
            Cookies.remove(VENDURE_AUTH_TOKEN_HEADER_KEY)
            localStorage.removeItem(USER_ID_KEY)
            set({ isAuthenticated: false, token: null, user: null, userId: null })
        },
    }
})
